import { Maybe, QuizResultEnum, QuizRevealAnswerEnum } from '@/types/schema';

import { QuizPerformanceFragment } from '../graphql/fragments/generated/QuizPerformance';

const getFetchCorrectAnswers = (
  revealAnswers?: Maybe<QuizRevealAnswerEnum>,
  quizPerformance?: QuizPerformanceFragment,
  retakeAllowedCount?: Maybe<number>,
) => {
  if (revealAnswers === QuizRevealAnswerEnum.Never) return false;

  if (revealAnswers === QuizRevealAnswerEnum.AfterLastAttempt) {
    if (retakeAllowedCount === undefined || retakeAllowedCount === null) return false;
    const attemptsUsed = quizPerformance?.attempts?.length ?? 0;
    const hasPassed = quizPerformance?.result === QuizResultEnum.Pass;
    return attemptsUsed >= retakeAllowedCount || hasPassed;
  }

  return true;
};

export default getFetchCorrectAnswers;
